// extracted by mini-css-extract-plugin
var _1 = "Panel_content__c2d8d";
var _2 = "Panel_divider__4ac13";
var _3 = "Panel_header__0a31b";
var _4 = "Panel_label__39751";
var _5 = "Panel_popover__62438";
var _6 = "Panel_selected__a573e";
var _7 = "Panel_wrapper__ed6db";
export { _1 as "content", _2 as "divider", _3 as "header", _4 as "label", _5 as "popover", _6 as "selected", _7 as "wrapper" }
